/**
 * @generated SignedSource<<c4d925a1b9d21e00816b38342a1f6c1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProjectTranscriptPage_TranscriptsQuery$variables = {
  projectId: string;
};
export type ProjectTranscriptPage_TranscriptsQuery$data = {
  readonly viewer: {
    readonly projectTranscripts: ReadonlyArray<{
      readonly id: string;
      readonly transcript: string | null;
      readonly createdAt: string | null;
    } | null> | null;
  } | null;
};
export type ProjectTranscriptPage_TranscriptsQuery = {
  variables: ProjectTranscriptPage_TranscriptsQuery$variables;
  response: ProjectTranscriptPage_TranscriptsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "projectId",
      "variableName": "projectId"
    }
  ],
  "concreteType": "ProjectTranscript",
  "kind": "LinkedField",
  "name": "projectTranscripts",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcript",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectTranscriptPage_TranscriptsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectTranscriptPage_TranscriptsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b3bc13261d080b807eea1b2370e7ceee",
    "id": null,
    "metadata": {},
    "name": "ProjectTranscriptPage_TranscriptsQuery",
    "operationKind": "query",
    "text": "query ProjectTranscriptPage_TranscriptsQuery(\n  $projectId: ID!\n) {\n  viewer {\n    projectTranscripts(projectId: $projectId) {\n      id\n      transcript\n      createdAt\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e342d1470ab0081e177665bafcb35f5c";

export default node;
